import {
  CURRENCY_EXCHANGE_CURRENT_SUCCESS,
  CURRENCY_EXCHANGE_LIST_SUCCESS,
} from "../constants";

const initialState = {
  list: [],
  currentId: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
  case CURRENCY_EXCHANGE_CURRENT_SUCCESS:
    return {
      ...state,
      currentId: action.payload,
    };
  case CURRENCY_EXCHANGE_LIST_SUCCESS:
    return {
      ...state,
      list: action.payload
    };
  default:
    return state;
  }
}